import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Libro } from 'src/app/modelos/libro';
import { LibroService } from 'src/app/services/libro.service';

@Component({
  selector: 'app-libro-qr',
  templateUrl: './libro-qr.component.html',
  styleUrls: ['./libro-qr.component.css']
})
export class LibroQrComponent implements OnInit {


  show:boolean = false;
 
  libro: any;

  constructor(private libroService:LibroService,private rutaActiva: ActivatedRoute, private spinner: NgxSpinnerService) {

  }

  ngOnInit() {

    this.cargarData();

  }

  cargarData(){
    this.spinner.show();
    this.libroService.GetById(this.rutaActiva.snapshot.params.id).subscribe(data => {
      this.spinner.hide();
      if(data.libros != null){
        this.libro = data.libros[0];
      }
      
      
    });
  }

}
